export default function() {
  Backbone.Stickit.addHandler([
    {
      selector: '.js-stickit-btn-group-radio',
      events: ['click'],
      update($el, val) {
        // apply active only to the one with the correct
        // value
        $el.removeClass('active');
        $el.has(`input[value="${val}"]`).addClass('active');
      },
      getVal($el, event) {
        return $(event.currentTarget)
          .find('input')
          .val();
      },
    },
  ]);
}



// WEBPACK FOOTER //
// ./js/backbone/utilities/add_btn_group_radio_stickit.js